import { render, staticRenderFns } from "./EmailTest.vue?vue&type=template&id=2861de9c&scoped=true&"
import script from "./EmailTest.vue?vue&type=script&lang=js&"
export * from "./EmailTest.vue?vue&type=script&lang=js&"
import style0 from "./EmailTest.vue?vue&type=style&index=0&id=2861de9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2861de9c",
  null
  
)

export default component.exports